module.exports = __webpack_public_path__ + "d3ccc5cc6bb6ef78f2cf17eba02d27b9.pdf";